import { Dispatch, AnyAction } from 'redux';
import { AppState } from '../redux';
import {
  STORE_NEWPASSWORD,
  STORE_CONFIRMPASSWORD,
  STORE_USERNAME_QUERY,
  STORE_TYPE_LINK_QUERY
} from '../reducers/forgot';
import { STORE_ERROR_MESSAGE, STORE_ERROR_BAR, STORE_SUCCESS_BAR, STORE_SUCCESS_MESSAGE } from 'src/reducers/errors';
import axios from 'axios';

export const getForgotUserName = (userNameb2a: string, typeLink: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    const userName = window.atob(userNameb2a);
    dispatch({ type: STORE_USERNAME_QUERY, userName } as AnyAction);
    dispatch({ type: STORE_TYPE_LINK_QUERY, typeLink } as AnyAction);

    return true;
  };
};

export const getForgotPage = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

  const newpassword: string = '';
  dispatch({ type: STORE_NEWPASSWORD, newpassword } as AnyAction);

  const confirmpassword: string = '';
  dispatch({ type: STORE_CONFIRMPASSWORD, confirmpassword } as AnyAction);

  return true;
};

export const saveNewPassword = (newpassword: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_NEWPASSWORD, newpassword } as AnyAction);
    return true;
  };
};

export const saveConfirmPassword = (confirmpassword: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CONFIRMPASSWORD, confirmpassword } as AnyAction);
    return true;
  };
};

export const doForgotPassword = async (
  dispatch: Dispatch<AppState>,
  getState: () => AppState
) => {
  const params = {
    userlogin: '',
    rpassword: '',
  };
  const paramsconfirmPassword = {
    confirmPassword: ''
  };
  params.userlogin = getState().forgotPassword.userName || '';
  params.rpassword = getState().forgotPassword.newpassword || '';
  paramsconfirmPassword.confirmPassword = getState().forgotPassword.confirmpassword || '';

  if (params.rpassword === '' && paramsconfirmPassword.confirmPassword === '') {
    const errorBar = true;
    const errorMessage = 'Please Enter the New Password and Confirm Password';
    dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
    return;
  } else {
    const errorBar = false;
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
  }

  if (params.rpassword === '') {
    const errorBar = true;
    const errorMessage = 'Please Enter the New Password';
    dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
    return;
  } else {
    const errorBar = false;
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
  }

  if (paramsconfirmPassword.confirmPassword === '') {
    const errorBar = true;
    const errorMessage = 'Please Enter the Confirm password';
    dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
    return;
  } else {
    const errorBar = false;
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
  }

  if (params.rpassword !== paramsconfirmPassword.confirmPassword) {
    const errorBar = true;
    const errorMessage = 'Password MisMatched';
    dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
    return;
  }

  if (params.rpassword.length < 5 && paramsconfirmPassword.confirmPassword.length < 5) {
    const errorBar = true;
    const errorMessage = 'Minimum 5 Characters Required';
    dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
    return;
  } else {
    const errorBar = false;
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
  }

  try {
    await axios.post(
      `${getState().environment.API_URL}resetPassword`,
      params
    );

    // console.error(response);
    const successBar = true;
    const successMessage =
      'Password changed Successfully';
    dispatch({ type: STORE_SUCCESS_MESSAGE, successMessage } as AnyAction);
    dispatch({ type: STORE_SUCCESS_BAR, successBar } as AnyAction);

    const newpassword: string = '';
    dispatch({ type: STORE_NEWPASSWORD, newpassword } as AnyAction);

    const confirmpassword: string = '';
    dispatch({ type: STORE_CONFIRMPASSWORD, confirmpassword } as AnyAction);

    const userName: string = '';
    dispatch({ type: STORE_USERNAME_QUERY, userName } as AnyAction);
    return;
  } catch (e) {
    // ==> console.error(e);
    const errorBar = true;
    const errorMessage = e.response.data.msg;
    dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);

    const newpassword: string = '';
    dispatch({ type: STORE_NEWPASSWORD, newpassword } as AnyAction);

    const confirmpassword: string = '';
    dispatch({ type: STORE_CONFIRMPASSWORD, confirmpassword } as AnyAction);
  }

};



// WEBPACK FOOTER //
// ./src/actions/forgotAction.ts